@use "../../scss/breakpoints";
@use "../../scss/colors";
@use "../../scss/utilities";

$light-grey: #f6f8f8;

.faq {
	background-color: colors.$nordic_light_background;
	border-radius: utilities.$border-radius;
	box-shadow: utilities.$box-shadow;
	padding: 24px 48px;
	margin-bottom: 24px;

	@include breakpoints.md-down {
		padding: 18px 18px;
	}

	&:last-of-type {
		margin-bottom: 0;
	}

	span {
		color: colors.$nordic_dark_grey;
		cursor: hand;
		cursor: pointer;
		display: flex;
		flex-direction: row;
		font-size: 24px;
		font-weight: 350;
		gap: 12px;
		line-height: 32px;

		@include breakpoints.md-down {
			font-size: 18px;

			line-height: 24px;
		}
	}

	p,
	ul {
		color: colors.$nordic_med_grey;
		font-size: 16px;
		font-weight: 350;
		line-height: 24px;
		margin-top: 8px;
		padding-left: 32px;

		a {
			color: colors.$nordic_lake;
			font-size: 16px;
			font-weight: 350;
			line-height: 24px;

			&:hover,
			&:focus-visible {
				text-decoration: underline;
			}
		}
	}
}
